import React from "react";
import autoBind from "react-autobind";
import {Rectangle} from "react-google-maps";
import {boundsToArray, arrayToBounds} from "../../../lib/google-maps";
import ImageOverlay from "../../../components/ImageOverlay";

class MapEditOverlay extends React.Component {
  constructor(props) {
    super(props);
    this._refs = {};
    autoBind(this);
  }

  handleOnBoundsChanged() {
    const bounds = this._refs.rectangle.getBounds();
    const boundsArray = boundsToArray(bounds);
    this.props.onBoundsChange(boundsArray);
  }

  render() {
    const {bounds, overlay} = this.props;
    const latLngBounds = arrayToBounds(bounds);
    return (
      <div>
        <Rectangle
          // key={new Date()}
          ref={ref => {
            this._refs.rectangle = ref;
          }}
          onBoundsChanged={this.handleOnBoundsChanged}
          bounds={latLngBounds}
          // editable
          draggable
          options={{
            fillOpacity: 0
            // strokeColor: 'transparent'
          }}
        />
        <ImageOverlay
          image={overlay.image.path}
          heading={overlay.heading}
          opacity={overlay.opacity}
          bounds={latLngBounds}
          map={window.MP_MAPEDIT_REF}
        />
      </div>
    );
  }
}

export default MapEditOverlay;



// WEBPACK FOOTER //
// ./src/pages/Facility/MapEditOverlay/index.jsx